// Wrapper for Google Material Symbols Rounded
// Usage: <Icon name="language" size={22} color="#0ABFAD" fill={1} />
export default function Icon({ name, size = 20, color = 'currentColor', fill = 1, style }) {
 return (
 <span
 className="material-symbols-rounded"
 style={{
 fontSize: size,
 color,
 fontVariationSettings: `'FILL' ${fill}, 'wght' 400, 'GRAD' 0, 'opsz' ${size}`,
 lineHeight: 1,
 display: 'inline-flex',
 alignItems: 'center',
 justifyContent: 'center',
 flexShrink: 0,
 ...style,
 }}
 >
 {name}
 </span>
 );
}
